import MyAppointments from '../../components/user/MyAppointments';

const MyAppointmentsDetailsPage = () => {
    return(
        <MyAppointments/>
    )
}

export default MyAppointmentsDetailsPage;